<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mb-4">
      <div class="col-12">
        <div class="card">
         <div class="card-body">
             <div class="mx-4 mb-4 mt-4">
                <div class="media">
                <div class="avatar-sm mr-3">
                  <span class="avatar-title rounded-circle bg-white text-secondary font-size-22">
                    <i class="bx bxs-message bx-lg mb-2"></i>
                  </span>
                </div>
                <div class="media-body">
                <b>{{this.id}} ( <span class="text-primary">{{name}}</span> )</b>
               <p>{{$t('news.description')}} : {{tableDataGroup.about}}</p>
                </div>
                </div>
                <div>
                  <div class="card">
                      <div class="card-body">
                            <div class="chat-users">
                            <div class="chat-conversation p-3">
                                <div class="row" >
                                  <div class="col-sm-12 text-right mb-3">
                                    <span class="text-secondary btn btn-sm btn-light mr-1" v-if="created_at_grouplistchat">  {{$t('all.updated')}}: {{formatDateRefresh(created_at_grouplistchat)}}</span> 
                                    <b-button class="btn btn-sm" variant="success" @click="chatListTelegram"><span v-if="loadingupdatechat"><b-spinner label="Loading ..."  small class="p-0" style="width: 0.6rem; height: 0.6rem;"></b-spinner> Loading..</span><span v-if="!loadingupdatechat"><i class="bx bx-history"></i> {{$t('all.update')}}</span></b-button>
                                  </div>
                                  <div class="col-sm-12 col-md-6">
                                    <!-- {{tableData}} -->
                                    <div id="tickets-table_length" class="dataTables_length">
                                      <label class="d-inline-flex align-items-center">
                                          {{$t('all.show')}}&nbsp;&nbsp;
                                        <b-form-select v-model="perPageChat" size="md" :options="pageOptionsChat" class="mx-1"></b-form-select>&nbsp;&nbsp;  {{$t('all.entries')}}
                                      </label>
                                    </div>
                                  </div>
                                  <!-- Search -->
                                  <div class="col-sm-12 col-md-6">
                                    <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                      <label class="d-inline-flex align-items-center">
                                          {{$t('all.search')}}:
                                        <b-form-input
                                          v-model="filterChat"
                                          type="search"
                                          :placeholder="$t('all.searchh')"
                                          class="form-control form-control-md ml-2"
                                        ></b-form-input>
                                      </label>
                                    </div>
                                  </div>
                                  <!-- End search -->
                                </div>
                                <div class="table-responsive mb-0">
                                      <b-table
                                        :items="tableDataChat"
                                        :fields="fieldsChat"
                                        bordered striped
                                        responsive="sm"
                                        :per-page="perPageChat"
                                        :current-page="currentPageChat"
                                        :sort-by.sync="sortByChat"
                                        :sort-desc.sync="sortDescChat"
                                        :filter="filterChat"
                                        :filter-included-fields="filterOnChat"
                                        @filtered="onFilteredChat"
                                      >
                                        <template #cell(date)="row">  
                                        <div class="row">
                                          <div class="col-sm-8">
                                           <b v-if="row.item.username">{{row.item.username}}</b><b v-else>Anonymous</b> <br>
                                            <span claas="text-secondary" v-if="row.item.message">{{row.item.message}}</span>  <small claas="text-danger p-2" v-else>joined</small> 
                                          </div>
                                          <div class="col-sm-4 text-right">
                                              <i class="bx bx-time-five align-middle mr-1"></i>
                                              {{formatDate(row.item.date)}}
                                          </div>
                                        </div>
                                        </template>
                                      </b-table>
                                </div>
                            </div>
                          </div>
                              <div class="col-sm-12 p-5 text-secondary"  v-if="!tableDataChat[0]">
                            <div class="text-center ">
                               <p>{{$t('all.dnf')}} Last 200 Chat</p>
                            </div>
                            </div>
                          <div class="col-sm-12 p-5" v-if="loadinglist && !tableDataChat">
                            <div class="text-center loading">
                                <b-spinner label="Loading..."></b-spinner>
                            </div>
                            </div>
                            <div class="float-right pr-3" v-if="tableDataChat[0]">
                              <ul class="pagination pagination-rounded mb-0">
                                    <!-- pagination -->
                                    <b-pagination v-model="currentPageChat" :total-rows="rowsChat" :per-page="perPageChat"></b-pagination>
                              </ul>
                          </div>
                      </div>
                    </div>
                </div>
          </div>
         </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import GroupService from "@/helpers/group.service.js";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import PreferenceService from "@/helpers/preference.service.js";
import appConfig from "@/app.config";
import moment from 'moment';

export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {

    return {
      id: this.$route.params.id,
      name: this.$route.params.name,
      loading:false,
      loadinglist:false,
      loadingupdatechat:false,
      loadingupdatemember:false,
      loadingupdatedetail:false,
      created_at_grouplistchat:"",
      created_at_grouplistmember:"",
      created_at_grouplistdetail:"",
      tableDataGroup:[],
      tableData:[],
      tableDataChat:[],
      totalMember:"",
      totalChat:"",
      elastic:"",
      title: 'Grup Chat List',
      items: [
        {
          text: "Home",
          href: "/"
        },
        {
          text:  'Grup Chat List',
          active: true
        }
      ],

      totalRowsChat: 1,
      currentPageChat: 1,
      perPageChat: 10,
      pageOptionsChat: [10, 25, 50, 100],
      filterChat: null,
      filterOnChat: [],
      sortByChat: "age",
      sortDescChat: false,
      fieldsChat: [
        { key: "date", sortable: true,  label:'Last Chat Member' },
        { key: "message_id", thClass: 'd-none', tdClass: 'd-none'},
        { key: "message", thClass: 'd-none', tdClass: 'd-none'},
        { key: "username", thClass: 'd-none', tdClass: 'd-none'},
      ],
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
     rowsChat() {
      return this.tableDataChat.length;
    }
  },
  mounted() {
    this.getPreferences();
    this.totalRows = this.items.length;
  },
  methods: {
    getPreferences(){
        PreferenceService.getAllElastic()
        .then((response) => {
            this.elastic = response.data.data[0].ip_address;
            this.getGroupDetail();
            this.groupChatList();
        })
        .catch((err) => {
            console.log(err);
        });
    },
    getGroupDetail(){
        this.loading = true;
          GroupService.getTelegramGroupDetailElastic(this.elastic, this.id)
          .then((response) => {
              this.created_at_grouplistdetail = response.data._source.created_at;
              this.tableDataGroup = response.data._source.detail_group;
              this.loading = false; 
              })
              .catch(err => {
                if(err == "Error: Request failed with status code 404"){
                    this.getGroupDetailTelegram();
                } else {
                    console.log(err);
                    this.loading = false; 
                }
          });
    },
    
    groupChatList() {
        GroupService.getTelegramChatElastic(this.elastic, this.id)
        .then((response) => {
              this.created_at_grouplistchat = response.data._source.created_at;
                  this.tableDataChat = []
                    response.data._source.listchat.forEach(val => {
                        const data = {    
                        "message_id" : val.message_id,
                        "date" : val.date,
                        "message" : val.message,
                        "username" : val.username,
                        }
                        if(data.username == this.name){
                        this.tableDataChat.push(data);
                        } 
                        this.loadinglist = false;  
                });
            })
            .catch(err => {
              if(err == "Error: Request failed with status code 404"){
                    // this.chatListTelegram();
                } else {
                    console.log(err);
                    this.loading = false; 
                }
          });
    },
    chatListTelegram() {
      this.loadinglist = true;
      this.loadingupdatechat = true;
        var data = {
            "group": this.id
        }
        console.log(data);
            GroupService.getTelegramGroupChat(data)
            .then((response) => {
                  this.tableDataChat = []
                  this.chat_list = response.data.output;
                  this.createChatElastic();
                  var today = new Date();
                  var time = today.toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
                  this.created_at_grouplistchat = time;
                    response.data.output.forEach(val => {
                        const data = {    
                        "message_id" : val.message_id,
                        "date" : val.date,
                        "message" : val.message,
                        "username" : val.username,
                        }

                        if(data.username == this.name){
                        this.tableDataChat.push(data);
                        } else {
                           this.tableDataChat == null;
                        }
                        // this.totalChat = response.data.Total_message
                        this.loadinglist = false;
                        this.loadingupdatechat = false;  
                });
                })
                .catch(err => {
                    this.loadinglist = false;  
                    this.loadingupdatechat = false;
                    console.log(err);
            });
    },
      createChatElastic(){
          var today = new Date();
          var time = today.toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
          const data = {
             "created_at": time,
             "username": this.id,
             "listchat": this.chat_list
        }
        GroupService.createGroupChatElastic(this.elastic, this.id, data)
        .then(response => {
            console.log('create chat',response);
        })
        .catch(err => {
            console.log('chat err ->',err);
        });
    },

    getGroupDetailTelegram(){
        this.loading = true;
        this.loadingupdatedetail = true;
        var data = {
            "group": this.id
        }
          GroupService.getTelegramGroupDetail(this.elastic, data)
            .then((response) => {
                  this.tableDataGroup = response.data.output[0];
                  this.loading = false;  
                  this.loadingupdatedetail = false;
                  this.createGroupDetailElastic();
                  var today = new Date();
                  var time = today.toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
                  this.created_at_grouplistdetail = time;
              })
              .catch(err => {
                  this.loading = false;  
                  this.loadingupdatedetail = false;
                  console.log(err);
          });
    },
    createGroupDetailElastic(){
        var today = new Date();
        var time = today.toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
        const data = {
             "created_at": time,
             "username": this.id,
             "detail_group": this.tableDataGroup
        }
        GroupService.createGroupDetailElastic(this.elastic, this.id, data)
        .then(response => {
            console.log('detail group',response);
        })
        .catch(err => {
            console.log('detail group err ->',err);
        });
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredChat(filteredItemsChat) {
      this.totalRowsChat = filteredItemsChat.length;
      this.currentPageChat = 1;
    },
    onDelete(id){
        console.log('delete data:', id);
    },
    onView(id){
        console.log('details data:', id);
    },
    formatDate(value){
        return moment(value).format("YYYY-MM-DD, hh:mm");
    },
    formatDateRefresh(value){
        return moment(value).format("YYYY-MM-DD, hh:mm");
    },
  }
};
</script>

<style scoped>
.badge{
    border-radius: 2%;
}
.btn{
    border-radius: 7%;
}
.card{
      box-shadow: 0 0 10px 0 rgba(100, 100, 100, 0.11);
}
.bg-dark{
    background-color: #2A3042;
}
</style>